import React, { createContext, useContext, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

export interface HeaderMenuAction {
  label: string;
  icon?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  onSelect: () => void;
}

interface HeaderSlots {
  host: HTMLElement | null;
  registerMenuAction: (id: string, action: HeaderMenuAction | null) => void;
}

export const HeaderActionsContext = createContext<HeaderSlots>({ host: null, registerMenuAction: () => undefined });

export const useHeaderMenuAction = (id: string, action: HeaderMenuAction | null) => {
  const register = useContext(HeaderActionsContext).registerMenuAction;
  const latest = useRef(action);
  latest.current = action;
  const active = action !== null;
  const disabled = Boolean(action && action.disabled);

  useEffect(() => {
    if (!latest.current) return undefined;
    register(id, { ...latest.current, disabled, onSelect: () => latest.current && latest.current.onSelect() });
    return () => register(id, null);
  }, [register, id, active, disabled]);
};

interface Props {
  children: React.ReactNode;
}

export default (props: Props) => {
  const { host } = useContext(HeaderActionsContext);
  return host ? ReactDOM.createPortal(props.children, host) : null;
};
